export class Question {

    public text: string;

    public answers: Answer[];

    public multiple: boolean;

    public isRange: boolean;

    constructor(text: string, answers: Answer[], multiple: boolean, isRange: boolean) {
        this.text = text;
        this.answers = answers;
        this.multiple = multiple;
        this.isRange = isRange;
    }

}

export class Answer {

    public text: string;
    public isChecked: boolean;
    public isRange: boolean;
    public val: number;

    constructor(text: string, val: number = -1) {
        this.text = text;
        this.isChecked = false;
        this.val = val;
        this.isRange = val > 0;
    }
}
